<template>
  <div class="explaining" v-if="Object.keys(setData.goods_info).length&&isShowExplaining" @click="jumpOuterPage({
      fullPath: setData.goods_info.goods_url
    })">
    <div class="good-img">
      <figure>
        <img :src="setData.goods_info.goods_img" alt="">
      </figure>
      <span class="label">讲解中</span>
      <div class="close">
        <span  @click.stop="isShowExplaining = !isShowExplaining"></span>
      </div>
    </div>
    <div class="bottom">
      <h5 class="com-two-line-els">{{ setData.goods_info.name}}</h5>
      <div class="powerful" @click.stop="jumpOuterPage({
      fullPath: setData.goods_info.link_href
    })"><span>¥</span>{{ setData.goods_info.min_price }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Explaining',
  props: {
    setData: {
      type: Object,
      default: () => {
      }
    },
    uid: {
      type: String,
      default: '0'
    }
  },
  data: () => ({
    // 是否讲解
    isShowExplaining: true,
    timer: null
  }),
  watch: {
    'setData.goods_info' (newVal, oldVal) {
      if (!this.isShowExplaining) {
        this.isShowExplaining = true
      }
      this.showExplaining()
    }
  },
  filters: {},
  created () { },
  mounted () {
    this.showExplaining()
  },
  methods: {
    // 8秒大图消失
    showExplaining () {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        if (this.isShowExplaining) {
          this.isShowExplaining = false
        }
      }, 8000)
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}
</script>
<style scoped lang="less">
.explaining {
    position: fixed;
    bottom: 183px;
    right: 16px;
    z-index: 200;
    width:122px;
    border-radius: 4px;
    border: 1px solid #F5F5F5;
    box-sizing: border-box;
    background:#fff;
    pointer-events: auto;
    .good-img {
      position: relative;
      figure {
        width: 120px;
        height: 120px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px 4px 0px 0px;
        }
      }

      .label {
        position: absolute;
        left: 4px;
        top: 4px;
        padding: 0 3px;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 2px;
        font-size: 10px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 12px;
      }

      .close {
        position: absolute;
        right: 4px;
        top: 4px;
        // padding-left:5px;
        // padding-bottom: 5px;;
        span{
          display:block;
          width: 12px;
          height: 12px;
          background-image: url("https://s.kcimg.cn/live/image/close_white_new.png");
          background-size: 100%;
        }
        cursor: pointer;
      }
    }

    .bottom {
      padding: 1px 2px 4px;

      .title {
        font-size: 10px;
        font-weight: 400;
        color: #03102A;
        word-break: break-all;
        line-height: 15px;
      }

      .powerful {
        width: 116px;
        height: 24px;
        padding: 0 30px 0 4px;
        margin-top:2px;
        box-sizing: border-box;
        background-image: url("https://s.kcimg.cn/live/image/explaining_qiang_new.png");
        background-size: 100%;
        font-size: 14px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 24px;
        text-align: center;
        span{
           font-size: 10px;
        }
      }
    }
  }
  @media screen and (min-width: 751px) {
    .explaining {
      left: 50%;
      margin-left: 244px;
    }
  }
</style>
